import { Navigation, Pagination, Swiper } from "swiper";

Swiper.use([Navigation, Pagination]);

export const activitiesInHeroEnhancer = function (el) {
    const swiper = new Swiper(el, {
        loop: true,
        autoplay: true,
        autoHeight: true,
        pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true,
        },
        navigation: {
            prevEl: el.querySelector(".swiper-button-prev"),
            nextEl: el.querySelector(".swiper-button-next"),
        },
    });
};
